import { Button, Form, Modal, Select } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { POST } from '../../../utils/apis'
import { assignMessage, errorMessage, getUserData, successMessage } from '../../../utils/helpers'
const AddContact = (props) => {
    const { Option } = Select
    const { selectedLanguage, language, user, playerContact, visible, handleOk, userActions } = props
    const players = useSelector(state => state?.userReducer?.players)
    const [loading, setLoading] = useState(false)
    const [form] = Form.useForm()
    const [disabledArray, setDisabledArray] = useState([])
    useEffect(() => {
        getUserData(user?._id, userActions)

        let arr = []
        playerContact?.length &&
            playerContact.map((v, i) => {
                arr.push(v?.contactId?.email)
            })
        setDisabledArray(arr)
    }, [])

    const onFinish = (values) => {
        values.userId = user?._id
        axios.post(POST.CREATE_CONTACT, values)
            .then((res) => {
                const { data } = res
                setLoading(false)
                if (data.success) {
                    successMessage(assignMessage(data?.message, language?.language))
                    form.resetFields()
                    handleOk()
                }
                else {
                    errorMessage(assignMessage(data?.message, language?.language))
                }
            })
            .catch((e) => {
                setLoading(false)
                errorMessage(assignMessage(e?.message, language?.language))
            })
    }

    return (
        <div>
            <Modal
                open={visible}
                onOk={handleOk}
                onCancel={handleOk}
                className='pop-info-modal'
                footer={null}
            >
                <p className='p-question' style={{ fontSize: '18px' }} >
                    {selectedLanguage?.subtitle_AddNewContacttoYourContacts}
                </p>
                <div className='form-div-in-modal'>
                    <Form
                        name='form'
                        form={form}
                        onFinish={onFinish}
                        layout={'vertical'}
                    >
                        <Form.Item
                            name='contactId'
                            hasFeedback
                            label={<p className='p-admin-title-text'>{selectedLanguage?.label_SelectNewContactEmail}</p>}
                            rules={[
                                {
                                    required: true,
                                    message: selectedLanguage?.error_SelectNewContactEmail
                                }
                            ]}
                        >
                            <Select
                                className='form-input-new-design-big-slam'
                                notFoundContent={selectedLanguage?.txt_NoDataFound}
                                placeholder={selectedLanguage?.PlaceHolder_SelectEmailOfYourNewContact}>
                                {players?.length ?
                                    players?.map((v, i) => {
                                        return (
                                            disabledArray.includes(v?.email) ? null :
                                                <Option value={v?._id}>{v?.email}</Option>
                                        )
                                    }) : null}
                            </Select>
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', }}>
                            <Form.Item>
                                <Button
                                    type='primary'
                                    htmlType='submit'
                                    loading={loading}
                                >
                                    {selectedLanguage?.button_AddnewContact}
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </Modal>
        </div>
    )
}
export default AddContact